<div class="menu-button-container" matRipple>
  <div *ngIf="!open">
    <span></span>
    <span></span>
    <span></span>
  </div>
  <mat-icon *ngIf="open" svgIcon="close"></mat-icon>
</div>
